import { createFileRoute, redirect } from '@tanstack/react-router';

/** The Developers group opens on its first topic, API keys; the address was the whole Developers page. */
export const Route = createFileRoute('/t/$tenant/settings/developers/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/t/$tenant/settings/developers/keys',
      params: { tenant: params.tenant },
      replace: true,
    });
  },
});
